import { render, staticRenderFns } from "./activeResult.vue?vue&type=template&id=7f7feb78&scoped=true&"
import script from "./activeResult.vue?vue&type=script&lang=js&"
export * from "./activeResult.vue?vue&type=script&lang=js&"
import style0 from "./activeResult.vue?vue&type=style&index=0&id=7f7feb78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7feb78",
  null
  
)

export default component.exports